<bt-loader [loaderId]="loaderId">
	@if(!!stylesQty){
	<div class="padding-left-small padding-right-small">
		<div class="card">
			<div class="margin-bottom-small">Select warehouse</div>
			<div class="warehouse-autocomplete">
				<bt-autocomplete
					[datasource]="warehouses.data"
					[currentSelected]="warehouses.selected"
					[settings]="warehouses.autocompleteSettings"
					[loaderId]="warehouses.loaderId"
					[page]="warehouses.page"
					(open)="onOpenWarehousesAutocomplete()"
					(nextPage)="getWarehouses(warehouses.page + 1)"
					(filterChange)="onWarehousesFilterChange($event)"
					(selected)="onSelectWarehouse($event)"></bt-autocomplete>
			</div>
			<div class="margin-top margin-bottom-small">
				Select the number of product you want in your order (you still have {{ maxItems }} products available to order)
			</div>
			<div class="flex center">
				<button class="icon-button" [disabled]="stylesQty <= 1" (click)="onClickStylesQty(-1)">
					<i class="fa fa-minus-circle"></i>
				</button>
				<input
					class="styles-qty margin-left-x-small margin-right-x-small"
					min="1"
					type="number"
					[max]="maxItems"
					[(ngModel)]="stylesQty"
					(ngModelChange)="onChangeStylesQty()" />
				<button class="icon-button" [disabled]="stylesQty === maxItems" (click)="onClickStylesQty(1)">
					<i class="fa fa-plus-circle"></i>
				</button>
			</div>
		</div>

		@if(warehouses.selected && styles.data){
		<ng-container>
			<div class="flex center margin-bottom margin-top">
				<h4 class="flex-1">Styles to shoot</h4>
				<div class="flex-0">
					<button (click)="onPlaceOrder()">
						<i class="fa fa-shopping-cart"></i>
						Place Order
					</button>
				</div>
			</div>
			<div class="card">
				@if(styles.data?.length){
				<table>
					<tr>
						@for(col of gridColumns; track col){
						<th [ngStyle]="{ width: col.width ? col.width + 'px' : null }">{{ col.title }}</th>
						}
					</tr>
					@for(item of styles.data; track item; let i = $index){
					<tr>
						@for(col of gridColumns; track col){
						<td>
							@if(col.type === gridColumnTypeEnum.ranking){
							<ng-container>
								{{ i + 1 }}
							</ng-container>
							} @if(col.type === gridColumnTypeEnum.default){
							<ng-container>
								{{ item[col.field] || ' - ' }}
							</ng-container>
							} @if(col.type === gridColumnTypeEnum.custom){
							<ng-container>
								{{ item[col.field] || ' - All size groups - ' }}
							</ng-container>
							}
						</td>
						}
					</tr>
					}
				</table>
				} @if(styles.data && !styles.data.length){
				<div class="no-data">
					<i class="fa fa-frown-o"></i>
					<div>There are no styles for selected warehouse</div>
				</div>
				}
			</div>
		</ng-container>
		} @if(!warehouses.selected){
		<div class="card no-data margin-top">
			<i class="fa fa-industry"></i>
			<div>Select a warehouse to view styles</div>
		</div>
		}
	</div>
	}@else{
	<div class="padding-left-small padding-right-small">
		<div class="card">
			<div class="no-data">
				<i class="fa fa-frown-o"></i>
				<div>Your status is not active</div>
			</div>
		</div>
	</div>
	}
</bt-loader>

@if(currentSidebarType === sidebarTypeEnum.customSidebar){
<bt-sidebar sidebarTitle="Place order" (exit)="currentSidebarType = null">
	<div class="full-height flex">
		<div class="flex-1 margin-bottom margin-top padding-left-x-small padding-right-x-small">
			<b>Are you sure you want create this order?</b>
			<div class="overflow padding-top padding-bottom">
				@for(item of styles.data; track item){
				<div class="padding-bottom-small">{{ item.fullName + ' | ' + item.colorFullName }}{{ item.sizeGroupName ? ' | ' + item.sizeGroupName : '' }}</div>
				}
			</div>
		</div>
		<div class="flex-0">
			<button class="full-width" (click)="placeOrder()">
				<i class="fa fa-shopping-cart"></i>
				Place order
			</button>
		</div>
	</div>
</bt-sidebar>
}
